<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2>Listado</h2> -->
        <TabNav :links="routesNav" @action="handleTabAction" />
        
    </div>
    
    <div class="container-body">

        <div v-if="orderFeedback" class="order-feedback" role="status">{{ orderFeedback }}</div>

        <div class="table-toolbar">
            <div class="toolbar-left">
            <label>
                Mostrar registros:
                <select v-model="pageSize" @change="onPageSizeChange">
                    <option :value="10">10</option>
                    <option :value="15">15</option>
                    <option :value="25">25</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </label>
            </div>
            <div class="toolbar-center">
            <label>
                Filtro Categorías:
                <select id="category"
                v-model="selectedCategory"
                    v-on:change="onChangeCategory">
                <option value="todas">
                    Cualquier capa
                </option>
                <option v-for="item in categories"
                    v-bind:key="item.index"
                    v-bind:value="item.id">
                    {{item.name}}
                </option>
                </select>
            </label>
            </div>
            <div class="toolbar-status">
                <label> Filtro Estado:
                <select id="status" v-model="selectedStatus" @change="onChangeStatus">
                    <option value="todos">Todos</option>
                    <option value="true">Activo</option>
                    <option value="false">Inactivo</option>
                </select>
                </label>
            </div>
            <div class="toolbar-right">
                <label>
                        Buscar:
                  <input
                    type="text"
                    v-model="searchQuery"
                    @keyup="onSearchKeyup"
                    placeholder="Buscar capa..."
                  />
                </label>
            </div>
            <div class="toolbar-clear">
                <button
                    v-if="hasActiveFilters"
                    type="button"
                    class="filters-clear-btn"
                    @click="clearFilters"
                >
                    Limpiar filtros
                </button>
            </div>
            <!-- Barra espejo del scroll horizontal de la tabla: ocupa el espacio
                 libre de esta fila, así no hay que ir al pie de la tabla a
                 buscar la barra real. Solo aparece cuando hay desborde. -->
            <div v-show="hOverflow > 0" class="toolbar-hscroll-wrap" aria-hidden="true">
                <span class="toolbar-hscroll-label">
                    <font-awesome-icon icon="arrows-alt-h" /> Desplazar tabla
                </span>
                <div
                    class="toolbar-hscroll"
                    ref="topScroll"
                    @scroll="syncTableFromTop"
                >
                    <div :style="{ width: 'calc(100% + ' + hOverflow + 'px)', height: '1px' }"></div>
                </div>
            </div>
        </div>

        <div class="table-scroll" ref="tableScroll" @scroll="syncTopFromTable">
        <table class="layers-table">
            <thead>
                <tr>
                    <th class="sortable col-nombre" @click="onSort('name')">
                        Nombre <font-awesome-icon :icon="getSortIcon('name')" />
                    </th>
                    <th class="sortable" @click="onSort('category_name')">
                        Categoría <font-awesome-icon :icon="getSortIcon('category_name')" />
                    </th>
                    <th class="sortable col-fuente" @click="onSort('fuente')">
                        Fuente <font-awesome-icon :icon="getSortIcon('fuente')" />
                    </th>
                    <th class="sortable" @click="onSort('provider.name')">
                        Proveedor <font-awesome-icon :icon="getSortIcon('provider.name')" />
                    </th>
                    <th class="geometry-column">Geometría</th>
                    <th class="sortable" @click="onSort('fecha_dato')">
                        Fecha del dato <font-awesome-icon :icon="getSortIcon('fecha_dato')" />
                    </th>
                    <th class="sortable" @click="onSort('fecha_actualizacion')" title="Fecha de actualización de la fuente del dato">
                        Actualización <font-awesome-icon :icon="getSortIcon('fecha_actualizacion')" />
                    </th>
                    <th class="sortable col-si-no" @click="onSort('es_vulnerable')" title="Permite ejecutar geoprocesos sobre esta capa">
                        Geoprocesos <font-awesome-icon :icon="getSortIcon('es_vulnerable')" />
                    </th>
                    <th class="sortable" @click="onSort('status')">
                        Estado <font-awesome-icon :icon="getSortIcon('status')" />
                    </th>
                    <th class="action-cell">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in layers" :key="item.id" :class="{ 'row-inactive': item.status === false }">
                    <td class="col-nombre" :title="item.name">{{ item.name }}</td>
                    <td>{{ layerCategoryName(item) }}</td>
                    <td class="col-fuente" :title="item.fuente">{{ item.fuente }}</td>
                    <td>{{ layerProviderLabel(item) }}</td>
                    <td class="geometry-column">
                        <GeometryTypeIcon
                            :type="layerGeometryType(item)"
                            :loading="isGeometryLoading(item)"
                        />
                    </td>
                    <td>{{ layerDateFormatter(item.fecha_dato) }}</td>
                    <td>{{ layerDateFormatter(item.fecha_actualizacion) }}</td>
                    <td class="col-si-no">{{ item.es_vulnerable === 'SI' ? 'Sí' : 'No' }}</td>
                    <td>{{ item.status === false ? 'Inactivo' : 'Activo' }}</td>
                    <td class="action-cell">
                        <div class="action-cell__buttons">
                            <router-link :to="'/capas/' + item.id" class="btn-action btn-ver">
                                <font-awesome-icon icon="eye" /> Ver
                            </router-link>
                            <router-link :to="'/capas/' + item.id + '/editar-capa'" class="btn-action btn-edit">
                                Editar
                            </router-link>
                            <router-link :to="'/capas/' + item.id + '/eliminar-capa'" class="btn-action btn-delete">
                                Eliminar
                            </router-link>
                        </div>
                    </td>
                </tr>
                <tr v-if="!layers || layers.length === 0">
                    <td colspan="10">No hay capas</td>
                </tr>
            </tbody>
        </table>
        </div>

        <Pagination
        v-show="totalPages!=0"
        v-bind:totalPages="totalPages"
        v-bind:currentPage="currentPage"
        v-bind:pageSize="pageSize"
        v-on:pagechanged="pageChangedClick"
        >
        </Pagination>

    </div>

    <LayerOrderAdminModal
        ref="layerOrderModal"
        :initial-category="selectedCategory === 'todas' ? '' : selectedCategory"
        @saved="onLayerOrderSaved"
    />

    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'
import GeometryTypeIcon from '@/components/layers/GeometryTypeIcon.vue'
import LayerOrderAdminModal from '@/views/layers/LayerOrderAdminModal.vue'
import { resolveLayerGeometryFamily, storedGeometryFamily } from '@/services/layers/geometryType.js'
import { layerProviderLabel } from '@/services/layers/providerLabels.js'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restLayer} from '@/components/mixin/restLayer.js'
import {restCategory} from '@/components/mixin/restCategory.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restLayer, restCategory],
    data(){
        return{
            message: '',
            selectedCategory: 'todas',
            selectedStatus: 'todos',
            searchQuery: '',
            sortKey: '',
            sortOrder: 'asc',
            pageSize: 15,
            debounceTimer: null,
            orderFeedback: '',
            orderFeedbackTimer: null,
            resolvedGeometryTypes: {},
            resolvingGeometryTypes: {},
            hOverflow: 0
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        TabNav,
        GeometryTypeIcon,
        LayerOrderAdminModal
    },
    computed: {
        hasActiveFilters: function(){
            return this.searchQuery !== '' ||
                this.selectedCategory !== 'todas' ||
                this.selectedStatus !== 'todos' ||
                this.sortKey !== ''
        },
        routesNav: function(){
          return [
                {name:'Opciones'},
                {name:'Crear capa' , path: '/capas/nueva-capa'},
                {name:'Ver categorías' , path: '/capas/categorias-de-capas'},
                {name:'Ver capas externas' , path: '/capas/capas-externas'},
                {name:'Definir Orden', action: 'define-layer-order', icon: 'sort'},
              ]
        },
        routesBread: function(){
          return [{name:'Capas' }]
        },
    },
    props: [],
    methods:{
        handleTabAction: function(action){
            if(action === 'define-layer-order') this.$refs.layerOrderModal.show()
        },
        onLayerOrderSaved: function(){
            this.sortKey = ''
            this.sortOrder = 'asc'
            this.currentPage = 1
            this.fetchLayers()
            this.orderFeedback = 'El orden de las capas fue actualizado correctamente.'
            clearTimeout(this.orderFeedbackTimer)
            this.orderFeedbackTimer = setTimeout(() => { this.orderFeedback = '' }, 5000)
        },
        fetchLayers: function (){
            const that = this;
            let promise;
            if(this.selectedCategory=="todas"){
                promise = this.getLayersPages(this.currentPage, this.searchQuery, this.sortKey, this.sortOrder, this.pageSize, this.selectedStatus);
            }
            else{
                promise = this.getLayersByCategory(this.currentPage, this.selectedCategory, this.searchQuery, this.sortKey, this.sortOrder, this.pageSize, this.selectedStatus)
            }
            // Recuperación de overrun: si una página quedó vacía y no es la primera,
            // volver a la última con datos (evita tabla vacía + paginación que desaparece)
            if(promise && promise.then){
                promise.then(function(){
                    if((!that.layers || that.layers.length === 0) && that.currentPage > 1){
                        that.currentPage = that.currentPage - 1;
                        that.fetchLayers();
                        return
                    }
                    that.resolveVisibleGeometryTypes()
                });
            }
        },
        pageChangedClick: function (page){
            if(page < 1) return;
            this.currentPage = page;
            this.fetchLayers();
        },
        onSearchKeyup: function(){
            clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(() => {
                this.currentPage = 1
                this.fetchLayers()
            }, 300)
        },
        onPageSizeChange: function(){
            this.currentPage = 1
            this.fetchLayers()
        },
        onSort: function(key){
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.sortKey = key
                this.sortOrder = 'asc'
            }
            this.currentPage = 1
            this.fetchLayers()
        },
        getSortIcon: function(key){
            if (this.sortKey !== key) return 'sort'
            return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down'
        },
        layerDateFormatter: function(date){
            return this.dateOnlyFormatter(date) || '—'
        },
        layerCategoryName: function(layer){
            const category = this.categories.find(function(element) {
                    return element.id == layer.id_category;
                });
            if(category == undefined)
            {
                return 'Categoría desconocida';
            }
            return category.name;
        },
        layerProviderLabel: layerProviderLabel,
        layerGeometryType: function(layer){
            const storedType = storedGeometryFamily(layer)
            if(storedType) return storedType
            return this.resolvedGeometryTypes[this.layerGeometryKey(layer)] || ''
        },
        layerGeometryKey: function(layer){
            return String((layer && (layer.id || layer._id)) || '')
        },
        isGeometryLoading: function(layer){
            return this.resolvingGeometryTypes[this.layerGeometryKey(layer)] === true
        },
        resolveVisibleGeometryTypes: function(){
            (this.layers || []).forEach((layer) => {
                const key = this.layerGeometryKey(layer)
                if(!key || storedGeometryFamily(layer) || this.resolvedGeometryTypes[key] !== undefined || this.resolvingGeometryTypes[key]) return

                this.$set(this.resolvingGeometryTypes, key, true)
                resolveLayerGeometryFamily(layer)
                    .then((family) => this.$set(this.resolvedGeometryTypes, key, family || 'unknown'))
                    .catch(() => this.$set(this.resolvedGeometryTypes, key, 'unknown'))
                    .finally(() => this.$set(this.resolvingGeometryTypes, key, false))
            })
        },
        onChangeCategory: function(){
            this.currentPage=1
            this.fetchLayers();
        },
        onChangeStatus: function(){
            this.currentPage = 1
            this.fetchLayers();
        },
        clearFilters: function(){
            clearTimeout(this.debounceTimer)
            this.searchQuery = ''
            this.selectedCategory = 'todas'
            this.selectedStatus = 'todos'
            this.sortKey = ''
            this.sortOrder = 'asc'
            this.currentPage = 1
            this.fetchLayers()
        },
        test: function(){
            console.log('TEST')
        },
        // Cuánto le falta a la tabla para caber. Alimenta la barra espejo: su
        // contenido fantasma mide (ancho propio + desborde), con lo que las dos
        // barras recorren exactamente los mismos píxeles.
        updateHorizontalOverflow: function(){
            const el = this.$refs.tableScroll
            this.hOverflow = el ? Math.max(0, el.scrollWidth - el.clientWidth) : 0
        },
        syncTableFromTop: function(){
            const top = this.$refs.topScroll
            const table = this.$refs.tableScroll
            if (top && table) table.scrollLeft = top.scrollLeft
        },
        syncTopFromTable: function(){
            const top = this.$refs.topScroll
            const table = this.$refs.tableScroll
            if (top && table) top.scrollLeft = table.scrollLeft
        }
    },
    updated () {
        // hOverflow solo cambia si el layout cambió, así que no re-renderiza en bucle
        this.updateHorizontalOverflow()
    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.layers? true:this.$router.push('/pagina-no-encontrada')
    },
    beforeMount() {
        
    },
    mounted () {
        this.getCategoriesNoPages();
        this.fetchLayers();
        this.updateHorizontalOverflow();
        window.addEventListener('resize', this.updateHorizontalOverflow);
    },
    beforeDestroy () {
        clearTimeout(this.debounceTimer)
        clearTimeout(this.orderFeedbackTimer)
        window.removeEventListener('resize', this.updateHorizontalOverflow)
    }
}
</script>

<style lang="scss" scoped>
// La barra espejo vive en la fila de filtros: toma el espacio sobrante (flex)
// y convive con "Limpiar filtros", que conserva su lugar antes de ella.
// La etiqueta y el pulgar grueso con borde son deliberados: una barra nativa
// fina suelta en medio de la página no se lee como algo arrastrable.
.toolbar-hscroll-wrap {
  flex: 1 1 12rem;
  min-width: 10rem;
  align-self: flex-end;
  margin-left: 1em;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.toolbar-hscroll-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--color-steel);
  user-select: none;
}

.toolbar-hscroll {
  overflow-x: auto;
  overflow-y: hidden;
  cursor: grab;
  border: 1px solid var(--color-fog);
  border-radius: 8px;
  background: var(--color-mist);
  padding: 2px;
}

.toolbar-hscroll:active {
  cursor: grabbing;
}

.toolbar-hscroll::-webkit-scrollbar {
  height: 14px;
}

.toolbar-hscroll::-webkit-scrollbar-track {
  background: transparent;
}

.toolbar-hscroll::-webkit-scrollbar-thumb {
  background: var(--color-steel);
  border-radius: 7px;
  border: 3px solid var(--color-mist);
}

.toolbar-hscroll::-webkit-scrollbar-thumb:hover {
  background: var(--color-navy);
}

.order-feedback {
  margin-bottom: 0.8rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid #a9d4ba;
  border-radius: 4px;
  background: #edf8f1;
  color: #24633b;
  font-size: 0.84rem;
}

.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1em;
  margin-bottom: 1em;
}

/*
Alinear "Mostrar registros" & Filtro Grupos & "Buscar" segun observacion SENAPRED 06/2026 ("2. Los selectores: "Mostrar" y "Filtro de grupo" no se encuentran alineados y tampoco tienen el mismo tamaño de texto:" y "3. El "Buscador de texto" no se encuentra alineado.")
1. Dedicar un div para cada herramienta
2. Agregar </label> para cada div (eso permite que cada div tenga el mismo "contenido" a nivel de estilo)
*/
.toolbar-left,
.toolbar-center,
.toolbar-status,
.toolbar-right,
.toolbar-clear{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.75em;
}

.table-toolbar label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.toolbar-right{
    flex: 1;
    justify-content: flex-start;
}

.toolbar-center select{
    min-width:220px;
    width:max-content;
    max-width:100%;
}

.toolbar-right input {
    width: 100%;
    max-width: 220px;   // choose your preferred size
    min-width: 180px;
}

// La tabla tiene 12 columnas y se salía del ancho de la página. El scroll vive
// en este contenedor y no en el <table>, para que la cabecera y el cuerpo se
// desplacen juntos.
// Solo scroll horizontal: acotar la altura cortaba la última fila por la mitad
// y dejaba dos barras compitiendo. Con la columna de acciones anclada casi no
// hace falta desplazarse, así que la barra al pie de la tabla no molesta.
.table-scroll {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  margin-bottom: 1em;
  -webkit-overflow-scrolling: touch;
}

.layers-table {
  width: 100%;
  // Por debajo de este ancho la tabla deja de aplastar las columnas y aparece
  // el scroll: con 12 columnas, comprimirlas dejaba los textos ilegibles.
  min-width: 1000px;
  border-collapse: collapse;
  margin-bottom: 0;
}

//Observacion SENAPRED 06/2026 ("4. La tabla tiene los textos muy grandes. Quizás podría ser mas pequeño y así mostrar mas registros.")
.layers-table th,
.layers-table td {
  padding: 0.55em 0.6em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  text-align: left;
  vertical-align: middle;
  font-size: 0.875em;
}

.layers-table thead th {
  background: var(--color-navy);
  color: #fff;
  white-space: nowrap;
  font-weight: 600;
}

.layers-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.layers-table th.sortable:hover {
  background: var(--color-steel);
}

.layers-table tbody tr:hover {
  background: rgba(59, 110, 148, 0.06);
}

.layers-table tbody tr.row-inactive {
  opacity: 0.55;
}

// La columna de acciones queda anclada a la derecha: con 12 columnas había que
// desplazarse hasta el final para alcanzar Ver/Editar/Eliminar de cada fila.
// Necesita fondo sólido porque el resto del contenido pasa por debajo, y la
// sombra al costado marca dónde termina lo que se desplaza.
.layers-table th.action-cell,
.layers-table td.action-cell {
  position: sticky;
  right: 0;
  z-index: 2;
  white-space: nowrap;
  // Sutil a propósito: la sombra se dibuja siempre, incluso cuando la tabla
  // entra completa y no hay nada tapado debajo.
  box-shadow: -5px 0 5px -5px rgba(0, 0, 0, 0.18);
}

.layers-table td.action-cell {
  background: var(--color-white);
}

.layers-table thead th.action-cell {
  background: var(--color-navy);
}

// El hover de la fila no llega a la celda anclada, que tiene fondo propio.
.layers-table tbody tr:hover td.action-cell {
  background: #eef4f9;
}

.layers-table tbody tr.row-inactive td.action-cell {
  background: #f7f8f9;
}

// La columna solo muestra Sí/No: el título largo era lo que la ensanchaba, así
// que se acorta a "Geoprocesos" (el nombre completo queda en el tooltip del th)
// y el ancho lo dicta el propio título en una línea.
.layers-table .col-si-no {
  text-align: center;
}

// Sin un ancho mínimo, los nombres largos se partían en tres líneas y las filas
// quedaban de alturas muy dispares.
.layers-table .col-nombre {
  min-width: 12rem;
}

// Nombres de instituciones largos ("Ministerio de Obras Públicas") estiraban
// la columna. max-width solo no basta en celdas de tabla: sin overflow el
// texto sigue de largo y se monta sobre la columna vecina. El nombre completo
// queda en el title de la celda.
.layers-table .col-fuente {
  max-width: 11rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layers-table .geometry-column {
  min-width: 6.6rem;
  text-align: center;
}

.action-cell__buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.4em;
  align-items: center;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  padding: 0.2em 0.55em;
  border-radius: 3px;
  font-size: 0.82em;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.12s;
  &:hover { opacity: 0.8; text-decoration: none; }
}

.btn-ver    { background: #e8f4fd; color: var(--color-navy); }
.btn-edit   { background: #fef9e7; color: #7d6608; }
.btn-delete { background: #fdf2f2; color: #922b21; }

.layers-table td:nth-child(4),
.layers-table td:nth-child(5),
.layers-table td:nth-child(6),
.layers-table td:nth-child(7),
.layers-table td:nth-child(8) {
  white-space: nowrap;
}
</style>
